import type {
  ChatProfile,
  ConversationParticipant,
  MessageItem
} from '@customTypes/chat';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface ChatStore {
  messages: MessageItem[];
  chatProfile: ChatProfile | null;
  currentConversationParticipants: ConversationParticipant[];
  updateConversationParticipants: (
    participants: ConversationParticipant[] | null
  ) => void;
  updateChatProfile: (chatProfile: ChatProfile | null) => void;
  setMessages: (message: MessageItem) => void;
}

export const useChatStore = create<ChatStore>()(
  devtools(
    persist(
      (set) => ({
        messages: [],
        chatProfile: null,
        currentConversationParticipants: [],
        setMessages: (messages) =>
          set((state) => ({ messages: [...state.messages, messages] })),
        updateChatProfile: (chatProfile) => set({ chatProfile }),
        updateConversationParticipants: (participants) => {
          if (participants) {
            set({ currentConversationParticipants: participants });
          }
        }
      }),
      {
        name: 'chat-store',
        storage: createJSONStorage(() => sessionStorage)
      }
    )
  )
);
